export const DEVICE_PLATFORM = Object.freeze({
  DESKTOP: 'desktop',
  PAD: 'pad',
  MOBILE: 'mobile',
});

export const DEVICE_OS = Object.freeze({
  ANDROID: 'android',
  IOS: 'ios',
  OTHER: 'other',
});
